import {
  Create,
  DateInput,
  TextInput,
  SimpleForm,
  useNotify,
  useRefresh,
  useRedirect,
  NumberInput,
  Toolbar,
  SaveButton,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

import { parse } from "query-string";
import { AutoCompleteCultureCode } from "./AutoCompleteCultureCode";


const CultureCreateToolbar = (props) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Toolbar {...props}>
      <SaveButton
        label="Save"
        submitOnEnter={false}
        onSuccess={({ data }) => {
          notify(`Isolate created, redirecting to "samples/cultures" view`);
          sleep(2000).then(() => {
            redirect(`/samples/${data.id_sample}/show/cultures`);
            refresh();
          });
        }}
      />
      <span>&nbsp;</span>
      <SaveButton
        label="Save & add another"
        onSuccess={({ data }) => {
          notify(`Culture created, redirecting to "create" view`);
          sleep(2000).then(() => {
            redirect(`/cultures/create?id_sample=${data.id_sample}`);
            refresh();
          });
        }}
        submitOnEnter={true}
      />
    </Toolbar>
  );
};

const CultureCreate = (props) => {
  const classes = useCreateStyles();

  const { id_sample: id_sample_string } = parse(props.location.search);
  const id_sample = id_sample_string ? parseInt(id_sample_string, 10) : "";

  const today = new Date();

  return (
    <Create
      {...props}
      title="Create culture"
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
    >
      <SimpleForm
        initialValues={{ id_sample }}
        toolbar={<CultureCreateToolbar />}
      >
        <AutoCompleteCultureCode></AutoCompleteCultureCode>
    
        <TextInput source="atmosphere" />

        <NumberInput source="num_isolates" />

        <NumberInput source="temperature" />

        <DateInput
          defaultValue={today}
          source="culture_date"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
        />

        <TextInput
          fullWidth
          source="notes"
          label="Notes"
          multiline
          minRows={6}
        />
      </SimpleForm>
    </Create>
  );
};

export default CultureCreate;
